<template>
	<b-container fluid class="no-padding">
		<b-row no-gutters>
			<b-col no-gutters>
				<b-navbar toggleable="lg" type="dark" variant="dark" fixed="top">
					<b-container style="width: 100%">
						<b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
						<!-- <b-navbar-brand href="#">
							<img 	src="../assets/img/logo.png"
									class="img-fluid brand-image">
						</b-navbar-brand> -->
						<b-collapse is-nav id="nav_collapse">
							<b-navbar-nav>
								<b-nav-item to="/overview"><span class="icon-home d-lg-none d-xl-inline"></span> Übersicht</b-nav-item>
								<b-nav-item to="/providers" v-if="$auth.check(['user', 'superadmin'])"><span class="icon-vcard d-lg-none d-xl-inline"></span> Anbieter</b-nav-item>
								<b-nav-item to="/coupons" v-if="$auth.check(['user', 'superadmin'])"><span class="icon-docs d-lg-none d-xl-inline"></span> Gutscheine</b-nav-item>
								<b-nav-item to="/media" v-if="$auth.check(['user', 'superadmin'])"><span class="icon-picture d-lg-none d-xl-inline"></span> Medien</b-nav-item>
								<b-nav-item to="/customers" v-if="$auth.check(['user', 'superadmin', 'support'])"><span class="icon-users d-lg-none d-xl-inline"></span> Kunden</b-nav-item>
                <!-- <b-nav-item to="/stats" v-if="$auth.check(['user', 'superadmin'])"><span class="icon-chart-bar"></span> Statistik</b-nav-item> -->
                <b-nav-item to="/texts" v-if="$auth.check(['user', 'superadmin'])"><span class="icon-doc-text d-lg-none d-xl-inline"></span> Texte</b-nav-item>
								<b-nav-item to="/users" v-if="$auth.check(['admin', 'superadmin'])"><span class="icon-users d-lg-none d-xl-inline"></span> Systembenutzer</b-nav-item>
							</b-navbar-nav>
		
						    <!-- Right aligned nav items -->
							<b-navbar-nav class="ml-auto">
								<b-nav-item-dropdown v-bind:text="fullName" right>
									<b-dropdown-item to="/profile"><span class="icon-user"></span>&nbsp;&nbsp;Profil</b-dropdown-item>
									<b-dropdown-item to="/help"><span class="icon-help-circled"></span>&nbsp;&nbsp;Hilfe</b-dropdown-item>
									<b-dropdown-item to="/imprint"><span class="icon-info-circled"></span>&nbsp;&nbsp;Datenschutz & Impressum</b-dropdown-item>
									<b-dropdown-item v-on:click="logout"><span class="icon-lock"></span>&nbsp;&nbsp;Abmelden</b-dropdown-item>
								</b-nav-item-dropdown>			
							</b-navbar-nav>			
						</b-collapse>
					</b-container>			
				</b-navbar>
			</b-col>
		</b-row>
		<b-row no-gutters>
			<b-col no-gutters>
				<b-container>
					<b-row>
						<b-col>
							<div class="space55"></div>
							<div class="tile-container">
								<div class="tile-content">
									<router-view></router-view>
								</div>
							</div>
						</b-col>
					</b-row>
				</b-container>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
export default {
	data: function() {
		return {
			
		};
	},
	computed: {
		fullName: function() {
			return this.$auth.user().firstname + ' ' + this.$auth.user().lastname;
		},
	},
	methods: {
		logout: function() {
			this.$auth.logout({
				makeRequest: true,
				redirect: '/login',
			});
		},
	}
}
</script>

<style scoped>
.brand-image {
	max-height: 30px;
}
.navbar-nav .nav-link {
	padding-right: 30px !important;
}
.navbar-dark .navbar-nav .show > .nav-link, .navbar-dark .navbar-nav .active > .nav-link, .navbar-dark .navbar-nav .nav-link.show, .navbar-dark .navbar-nav .nav-link.active {
    color: #ff6600;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue